import { InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // Filter args are keyArgs: each filter combination keeps its own paginated list,
        // so changing filters swaps the list instead of merging pages across filters.
        allGroupsForLms: relayStylePagination([
          'active',
          'finished',
          'search',
          'courseId',
          'groupIds',
          'lessonDate',
        ]),
      },
    },
  },
});
